import { Timer } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useVault } from "@/context/VaultContext";
import { TIMERS } from "@/lib/selectors";

export function TimerSelect({ sid, value }) {
  const { setTimer } = useVault();
  return (
    <Select value={String(value)} onValueChange={(v) => setTimer(sid, Number(v))}>
      <SelectTrigger data-testid="burn-timer-select" className="h-8 w-[92px] bg-void border-rim rounded-secure text-xs text-ash gap-1">
        <Timer size={14} strokeWidth={1.5} className="text-flare" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="bg-nebula border-rim text-ash rounded-secure">
        {TIMERS.map((t) => (
          <SelectItem key={t.value} value={String(t.value)} data-testid={`burn-timer-option-${t.value}`}>{t.label}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
